import React from "react";
import SocCoverageIcons from "../Icons/SocCoverageIcons";

interface ISocCoverageCard{
  title: string;
  counterCurrent: number;
  counterMax: number;
  type?: string;
  lastGivenDate?: string;
}

const SocCoverageCardOld = ({
  title,
  counterCurrent,
  counterMax,
  lastGivenDate,
  type= "general",
}: ISocCoverageCard) => {
  return (
    <div className="flex-1 bg-white p-3 flex flex-col justify-between items-center rounded-lg gap-2">
      <SocCoverageIcons type={type} isComplete={counterCurrent===counterMax && lastGivenDate!==undefined} />
      <div className="text-center">
        <div className="text-sm font-semibold">{title}</div>
        <div className="text-xs text-gray-1">
          {(counterCurrent === 0 || !lastGivenDate) ? "Not Used" : `Used ${lastGivenDate}`}
        </div>
      </div>
      <div className="text-xs text-gray-1">{`${counterCurrent}/${counterMax}`}</div>
    </div>
  );
};

export default SocCoverageCardOld;
